import moment from "moment";
import React, { useState, useEffect, useMemo } from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";

import { Colors, Constants, Fonts } from "../../../../config";
import { FestivalDao, VenueDao } from "../../../../DAO";
import VenueList from "./VenueList";
import { getClass } from "../../../../helpers/formatHelpers";
const PAGE_SIZE = 5;
const NearByVenueView = (props) => {
  const { isMobileVersion, category } = props;
  const { longitude, latitude, startDate, endDate, id } = props.item;
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [lastPageCount, setLastPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isShowLoadMore = items.length < totalCount;

  useEffect(() => {
    getNearByVenues();
  }, [id]);
  const getNearByVenues = (page = 0) => {
    if (isLoading) return;
    setIsLoading(true);
    const range =
      process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
        ? 10
        : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
        ? 10
        : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
        ? 10
        : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
        ? 50
        : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
        ? 60
        : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
        ? 300
        : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
        ? 100
        : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
        ? 200
        : process.env.NEXT_PUBLIC_APP_NAME == "LuxResortClub"
        ? 50
        : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
        ? 5
        : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
        ? 60
        : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
        ? 200
        : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
        ? 100
        : 100;
    const params = {
      range,
      longitude,
      latitude,
      pageSize: 5,
      pageIndex: page,
      nearByVenueId: id,
      categoryType: props.category,
    };
    VenueDao.find(params)
      .then((result) => {
        if (page == 0) {
          setItems(result.data);
        } else {
          setItems([...items, ...result.data]);
        }
        setLastPageCount(result.data.length);
        setTotalCount(result.totalCount);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const onLoadMore = () => {
    if (lastPageCount == PAGE_SIZE && !isLoading) {
      setPageIndex(pageIndex + 1);
      getNearByVenues(pageIndex + 1);
    }
  };
  return (
    <View style={[styles.container, props.style]}>
      <div className={isMobileVersion ? "px-4" : ""}>
        <View
          style={[
            styles.itemContainer,
            isMobileVersion ? { height: 32, width: 120, marginTop: 30 } : {},
          ]}>
          <Text
            style={[
              styles.title,
              isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
            ]}>
            <h2>Nearby</h2>
          </Text>
          <Text
            style={[
              styles.description,
              isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
            ]}>
            {totalCount}
          </Text>
        </View>
      </div>
      <VenueList
        items={items}
        category={category}
        isMobileVersion={isMobileVersion}
      />
      {isShowLoadMore && (
        <TouchableOpacity
          style={
            isMobileVersion
              ? styles.mobileLoadMoreButtonContainer
              : styles.loadMoreButtonContainer
          }
          onPress={onLoadMore}>
          <Text
            style={[
              styles.buttonText,
              isMobileVersion && { fontSize: 12, lineHeight: 12 },
            ]}>
            VIEW MORE
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 25,
    marginLeft: 16,
    marginBottom: 30,
    height: 50,
    width: 200,
    backgroundColor: getClass("bg-gray1"),
  },
  container: {
    alignSelf: "stretch",
  },
  title: {
    color: "white",
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    fontFamily: Fonts.primaryBold,
  },
  description: {
    color: getClass("text-gray2"),
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    marginLeft: 8,
    fontFamily: Fonts.primaryBold,
  },
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: getClass("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: getClass("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  buttonText: {
    color: getClass("text-white"),
    fontFamily: Fonts.primaryBold,
    fontSize: 16,
    textAlign: "center",
  },
});

export default NearByVenueView;
